import { render } from "./WishListModal.vue?vue&type=template&id=a646f4b6&scoped=true"
import script from "./WishListModal.vue?vue&type=script&lang=js"
export * from "./WishListModal.vue?vue&type=script&lang=js"

import "./WishListModal.vue?vue&type=style&index=0&id=a646f4b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Azizi\\Downloads\\Kad Adeeb\\adeebxhanna\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a646f4b6"]])

export default __exports__